//--------------------------------------------------------------------------
// <copyright file="Footer.js" company="Microsoft">
// Copyright (c) Microsoft Corporation. All rights reserved.
// </copyright>
//--------------------------------------------------------------------------
import React from 'react'

/// <summary>
/// Component having links to multiple footer fields.
/// </summary>
const Footer = () => {
  return (
    <div className={'Footer'} data-testid="footer">
      <a className={'Footer-links'} rel="noreferrer noopener" target="_blank" href="https://learn.microsoft.com/en-us/microsoftteams/sip-gateway-plan">Plan SIP Gateway</a>
      <a className={'Footer-links'} rel="noreferrer noopener" target="_blank" href="https://www.microsoft.com/en-US/servicesagreement/">Terms of use</a>
      <a className={'Footer-links'} rel="noreferrer noopener" target="_blank" href="https://privacy.microsoft.com/en-US/privacystatement">Privacy & cookies</a>
    </div>
  )
}

export default Footer
